import React from "react";
import { Box } from "@mui/material";
import Header from "../../../component/Global/Heading/Heading";
import UserNavProfile from "../../../component/Global/user-Profile/user_profile";

export const Profile = () => {
  return (
    <section className={"section"}>
      <Box m={"14rem"}>
        <Header title={"Profile"} subtitle={"Username"} />
        <section className="section">
          <UserNavProfile />   
        </section>
      </Box>
    </section>
  );
};
